import React from "react";
import { Loader2 } from "lucide-react";

/**
 * Submit button used inside lead forms.
 * full-width on mobile, auto-width right-aligned on desktop.
 */
export const FormSubmit = ({
    label = "Submit",
    submittingLabel = "Submitting…",
    submitting = false,
    "data-testid": testId,
}) => (
    <div className="mt-2 flex sm:justify-end">
        <button
            type="submit"
            disabled={submitting}
            data-testid={testId}
            className="zen-glow-on-hover inline-flex w-full items-center justify-center gap-2 rounded-full bg-[var(--accent)] px-7 py-3.5 text-[14.5px] font-medium text-[#0a0a0b] transition-all duration-300 ease-luxury hover:brightness-110 disabled:opacity-60 disabled:pointer-events-none sm:w-auto"
        >
            {submitting && (
                <Loader2 className="h-4 w-4 animate-spin" strokeWidth={2} />
            )}
            <span>{submitting ? submittingLabel : label}</span>
        </button>
    </div>
);

export default FormSubmit;
